export enum Roles {
  SUPER_ADMIN = "Super Admin",
  CUSTOMER = "customer",
  AFFILIATE = "affiliate",
  MANAGER = "manager",
  AFFILIATE_MANAGER = "affiliate-manager",
  API_USER = "api-user",
  SUPPORT = "support",
  FINANCE = "finance",
  ADMIN = "Admin",

  // Prefixed AuthorTool roles (actual values remain as per API)
  AUTHORE_SUPER_ADMIN = "super-admin",
  AUTHORE_ADMIN = "admin",
  AUTHORE_DEVELOPER = "developer",
}
